
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useUserRole = (
  setUserRole: (role: string | null) => void,
  setProviderId: (id: string | null) => void
) => {
  const getUserRoleAndProvider = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (session) {
      const { data: roleData } = await supabase
        .from('user_roles')
        .select('role, provider_id')
        .eq('user_id', session.user.id)
        .single();
      
      setUserRole(roleData?.role || null);
      
      if (roleData?.role === 'strategy_provider') {
        setProviderId(roleData?.provider_id || null);
      }
    }
  };

  useEffect(() => {
    getUserRoleAndProvider();
  }, []);

  return { getUserRoleAndProvider };
};
